export * from "./image-picture.component";
export * from "./image.pipe";
export * from "./module/image-module";


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/custom-image/index.ts